//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';

import LanguageMixin from '@motionelements/core/src/components/mixins/language.mixin.js';

export default {
  name: 'main-menu-language-list',
  mixins: [LanguageMixin],
  data() {
    return {
      faCheck,
      navigatorLanguages: [],
    };
  },
  mounted() {
    this.navigatorLanguages = window.navigator.languages;
  },
  computed: {
    ...mapState({
      languages: state => state.app.languages,
    }),
    activeLanguageCode() {
      return this.$i18n.locale;
    },
    browserLanguageCodes() {
      // create arrow of activeLanguageCode and browserLanguageCodes without duplicates
      // use .split('-')[0] to compare zh-TW or zh-CN with zh-hant
      const browserLanguageCodes = [
        this.activeLanguageCode, // Always show selected language first
        'en', // Always include English next to selected language
        ...this.navigatorLanguages,
      ].map((code) => code.split('-')[0]);
      return [...new Set(browserLanguageCodes)];
    },
    suggestedLanguagesCodes() {
      const suggestedLanguagesCodes = this.browserLanguageCodes
        .filter(code => !!this.languages.find(language => language.code.split('-')[0] === code));
      return suggestedLanguagesCodes.length > 1 ? suggestedLanguagesCodes.slice(0, 3) : [];
    },
    suggestedLanguages() {
      return this.suggestedLanguagesCodes.map(languageCode => this.languages.find(({ code }) => code.split('-')[0] === languageCode));
    },
    otherLanguages() {
      return this.languages.filter(language => !this.suggestedLanguagesCodes.includes(language.code.split('-')[0]));
    },
  },
};
